










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { METHODS, INVOICE_STATUSES } from '@/constants/payment';

@Component({
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('ServiceRequest', {
      activeServiceRequest: 'activeServiceRequest',
    }),
    ...mapGetters('Auth', {
      hasValidatedCreditLimit: 'hasValidatedCreditLimit',
    }),
  },
})
export default class ServiceRequestReadServiceOrderPaymentMethods extends Vue {
  @Prop() readonly create!: () => void;

  isLoading = false;
  isMounted = false;
  paymentMethods = METHODS;
  invoiceStatuses = INVOICE_STATUSES;
  invoiceStatus = null;

  activeBusiness!: Model;
  activeServiceRequest!: Model;

  website = process.env.VUE_APP_WP_BASE;

  hasValidatedCreditLimit!: boolean;

  beforeMount() {
    if (!this.isInvoiceUnauthorized) {
      let action = 'Booking/checkCreditLimit';
      if (this.activeServiceRequest) {
        action = 'ServiceRequest/checkCreditLimit';
      }
      this.$store.dispatch(action).then((response) => {
        this.isMounted = true;
        this.invoiceStatus = response.data.data;
      });
    } else {
      this.isMounted = true;
    }
  }

  placeInvoiceOrder() {
    if (!this.hasValidatedCreditLimit) {
      return;
    }

    this.isLoading = true;
    const serviceOrder = {
      business_oid: this.activeBusiness.object_id,
      service_request_oid: this.activeServiceRequest.object_id,
      payment_method: this.paymentMethods.INVOICE.key,
    };
    this.$store
      .dispatch('ServiceOrder/create', serviceOrder)
      .then((invoiceStatus) => {
        this.invoiceStatus = invoiceStatus;
        if (this.isInvoiceInsuffientCredit || this.isInvoiceUnauthorized) {
          // if failed
          this.isLoading = false;
        } else {
          // if success, consume the booking
          this.$emit('consume');
        }
      });
  }

  get isInvoiceInsuffientCredit() {
    return (
      this.invoiceStatus ==
      this.invoiceStatuses.INVOICE_STATUS_INSUFFICIENT_CREDIT.key
    );
  }

  get isInvoiceUnauthorized() {
    return (
      this.invoiceStatus ==
        this.invoiceStatuses.INVOICE_STATUS_UNAUTHORIZED.key ||
      !this.hasValidatedCreditLimit
    );
  }

  toCreditCheck() {
    this.$router.push({
      name: 'business-credit-check',
    });
  }

  toTermsAndConditions() {
    this.$router.push({
      name: 'terms-and-conditions',
    });
  }
}
